export const QuizMain = () => {
  const $quizMain = document.querySelector("section.quiz-main");
  if ($quizMain) {
    const $siteHeader = document.querySelector(
      ".tribe-site-header.js-site-header"
    );
    const setQuizHeight = () => {
      const siteHeaderHeight = $siteHeader.getBoundingClientRect().height;
      $quizMain.style.setProperty("--quiz-height", `${siteHeaderHeight}px`);
    };

    window.addEventListener("resize", () => {
      setQuizHeight();
    });
    setQuizHeight();

    const $quizMainContents = $quizMain.querySelector(".quiz-main__contents");

    const $contentsInfo = $quizMainContents.querySelector(".contents__info");
    const $quizButtons = $contentsInfo.querySelectorAll(
      ".info__actions button.quiz-main__button.quiz-main__button--is-quiz"
    );

    const $quizOctaneai = $quizMain.querySelector(".quiz__octaneai");

    $quizButtons.forEach(($quizButton) => {
      $quizButton.addEventListener("click", (event) => {
        event.preventDefault();
        $quizOctaneai.classList.add("quiz__octaneai--active");
        $quizMainContents.classList.add("quiz-main__contents--inactive");
        window.scrollTo(0, 0);
      });
    });

    document.addEventListener(
      "octane.quiz.questionLoaded",
      function (e) {
        // your code for when the question is loaded into the screen

        window.scrollTo(0, 0);
      },
      false
    );

    document.addEventListener(
      "octane.quiz.completed",
      function (e) {
        // your code for building and handling the results page

        const answers = e.detail?.answers;
        const product_blocks = e.detail?.product_blocks;
        const sections = e.detail?.sections;

        const coffee_quiz_answers = {
          time: Date.now(),
          answers: answers,
          product_blocks: product_blocks,
          sections: sections,
        };

        localStorage.setItem(
          "coffee_quiz_answers",
          JSON.stringify(coffee_quiz_answers)
        );

        window.location = "/pages/coffee-quiz-results";
      },
      false
    );
  }
};

export default QuizMain;
